import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingSpinner = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '250px',
    }}
  >
    <CircularProgress color="primary" />
  </Box>
);

export default LoadingSpinner;
